/* The client app's empty state (the Bookings page's mockup Frame 4): a gold calendar orb, a title and one line.
 Shared by Bookings and the Book screen's empty tabs. */
.emptyBlock {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 44px 40px 30px;
}
.emptyOrb {
  width: 74px;
  height: 74px;
  border-radius: 50%;
  background: radial-gradient(circle at 30% 28%, rgba(var(--accent-hot-rgb), 0.28) 0%, rgba(var(--accent-deep-rgb), 0.12) 100%);
  border: 1px solid rgba(var(--accent-rgb), 0.22);
  display: grid;
  place-items: center;
  color: var(--accent);
  margin-bottom: 18px;
}
.emptyOrb svg {
  width: 30px;
  height: 30px;
  stroke-width: 1.5;
}
.emptyTitle {
  font-family: var(--client-font-heading, 'EB Garamond', Georgia, serif);
  font-weight: 500;
  font-size: 22px;
  letter-spacing: -0.02em;
  color: var(--text-primary);
  margin-bottom: 6px;
}
.emptySub {
  font-size: 13px;
  color: var(--text-secondary);
  line-height: 1.5;
  max-width: 260px;
}
